<template>
  <LKAsideMenuItem
    :to="linkTo"
    :label="label"
    :count="count"
    :new-count="notViewedCount"
    :children="children"
    @click="handleClick"
  />
</template>

<script>
import { LK_PUBLICATIONS_ROUTES } from '@/views/LKPublications/utils'
import LKAsideMenuItem from './LKAsideMenuItem.vue'
import { lkMapper } from '@/store/modules/lk'


export default {
  name: 'LKAsideMenuItemTopicLK',
  components: {
    LKAsideMenuItem,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    count: {
      type: Number,
      default: 0,
    },
    slug: {
      type: String,
      required: true,
    },
    children: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...lkMapper.mapState(['topics']),
    linkTo() {
      return {
        name: LK_PUBLICATIONS_ROUTES.LIST,
        params: { topic_slug: this.slug },
      }
    },
    notViewedCount() {
      const idx = this.topics.findIndex(({ slug }) => slug === this.slug)
      return idx >= 0 ? this.topics[idx].not_viewed_publications_count : 0
    },
  },
  methods: {
    handleClick() {
      this.$emit('submenu-clicked', this.children)
    },
  },
}
</script>

